import { SUBTYPE_DP_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useSubtypeDPList } from './hook';
import { SubtypeDPListProps } from './props';

export const SubtypeDPList = ({ filters }: SubtypeDPListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useSubtypeDPList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${SUBTYPE_DP_DETAIL}/${item.id}`, '_blank')
            }
        />
    );
};
